import { Plane, ShoppingCart, ShoppingBag, Building2, LayoutGrid } from 'lucide-react';
import { DestinationType } from '@/types';
import { cn } from '@/lib/utils';

interface FilterChipsProps {
  selectedFilter: DestinationType | 'all';
  onFilterChange: (filter: DestinationType | 'all') => void;
}

const filters: { id: DestinationType | 'all'; label: string; icon: typeof Plane }[] = [
  { id: 'all', label: 'All', icon: LayoutGrid },
  { id: 'airport', label: 'Airport', icon: Plane },
  { id: 'grocery', label: 'Grocery', icon: ShoppingCart },
  { id: 'mall', label: 'Mall', icon: ShoppingBag },
  { id: 'campus', label: 'Campus', icon: Building2 },
];

const FilterChips = ({ selectedFilter, onFilterChange }: FilterChipsProps) => {
  return (
    <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
      {filters.map((filter) => {
        const Icon = filter.icon;
        const isSelected = selectedFilter === filter.id;

        return (
          <button
            key={filter.id}
            onClick={() => onFilterChange(filter.id)}
            className={cn(
              "flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200",
              isSelected
                ? "bg-primary text-primary-foreground shadow-warm"
                : "bg-card text-muted-foreground border border-border hover:border-primary/30 hover:text-foreground"
            )}
          >
            <Icon className="w-4 h-4" />
            {filter.label}
          </button>
        );
      })}
    </div>
  );
};

export default FilterChips;
